export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q02_a.24ecc5ab.png";